import { render, staticRenderFns } from "./AddressClass.vue?vue&type=template&id=01613510&functional=true"
import script from "./AddressClass.vue?vue&type=script&lang=js"
export * from "./AddressClass.vue?vue&type=script&lang=js"
import style0 from "./AddressClass.vue?vue&type=style&index=0&id=01613510&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports